import { show_hide } from '../modules/projects';

export default {
	init() {
		// JavaScript to be fired on the home page
		show_hide();
	},
	finalize() {
		// JavaScript to be fired on the home page, after the init JS
	},
};



// WEBPACK FOOTER //
// ./scripts/routes/single.js